
import { PickupScheduleController } from "@/app/ui/controllers/PickupScheduleController";
import { PickupCorporateAddress } from "@/domain/entities/PickupSchedule";
import { Vue, Options, prop } from "vue-class-component";
import ModalAddNewAddress from "../modal-add-new-address/index.vue";
import {
  AddressFormSuccessPayload,
  AddressFormType
} from "./types";

class Props {
  isShown = prop<boolean>({
    default: false,
    type: Boolean
  });
  clientId = prop<number>({
    default: 0,
    required: false,
  });
  selectedAddress = prop<PickupCorporateAddress>({
    required: true
  });
}

@Options({
  emits: [
    "update:isShown",
    "selectAddress",
    "updateDefaultAddress",
    "defaultAddressChanged",
    "addressDeleted",
    "addressFormSuccess"
  ],
  components: {
    ModalAddNewAddress
  },
  watch: {
    isShown(isVisible: boolean) {
      if (!isVisible) {
        this.resetAddressFlow();
      }
    }
  }
})
export default class SavedAddressList extends Vue.with(Props) {
  isMainAddress = true;
  formType: AddressFormType = "add";
  isAddAddress = false;
  editData = new PickupCorporateAddress();
  isDeleteConfirm = false;
  addressWillDeleted: PickupCorporateAddress | null = null;
  isForceDefault = false;

  get listDataSavedAddress(): PickupCorporateAddress[] {
    return PickupScheduleController.listPickupCorporateAddress;
  }

  get listAddressLimit(): number {
    return PickupScheduleController.pickupCorporateAddessLimit;
  }

  onClose() {
    this.resetAddressFlow();
    this.$emit("update:isShown", false);
  }

  onChooseButtonPressed(data: PickupCorporateAddress) {
    this.$emit("selectAddress", data);
    this.onClose();
  }

  async setPickupCorporateAddressDefault(data: PickupCorporateAddress) {
    const isUpdated = await PickupScheduleController.setPickupCorporateAddressDefault(
      data
    );
    if (!isUpdated) {
      return;
    }
    this.$emit("updateDefaultAddress");
    this.$emit("defaultAddressChanged", data);
    this.onClose();
  }

  openCoordinates(coordinates: string) {
    if (!coordinates) {
      return;
    }
    const query = coordinates
      .split(",")
      .map(value => encodeURIComponent(value.trim()))
      .join(",");
    const url = `https://www.google.com/maps?q=${query}`;
    window.open(url, "_blank", "noopener,noreferrer");
  }

  onChooseDelete(data: PickupCorporateAddress) {
    this.isDeleteConfirm = true;
    this.addressWillDeleted = data;
  }

  async onSubmitDelete() {
    this.isDeleteConfirm = false;
    if (this.addressWillDeleted !== null) {
      const isDeleted = await PickupScheduleController.deletePickupCorporateAddressDefault(
        this.addressWillDeleted
      );
      if (!isDeleted) {
        return;
      }
      setTimeout(() => {
        this.$emit("addressDeleted");
      }, 300);
    }
  }

  showModalAddAddress(type: AddressFormType, data?: PickupCorporateAddress) {
    if (type === "edit") {
      this.isForceDefault = data?.pcaIsDefault || false;
    } else {
      const hasExistingAddress =
        (this.selectedAddress && this.selectedAddress.pcaId > 0) ||
        this.listDataSavedAddress.length > 0;

      this.isForceDefault = !hasExistingAddress;
    }
    this.formType = type;
    this.editData = data || new PickupCorporateAddress();
    this.isAddAddress = true;
  }

  closeModalAddress() {
    this.resetAddressFlow();
    this.$emit("updateDefaultAddress");
  }

  resetAddressFlow() {
    this.isAddAddress = false;
    this.formType = "add";
    this.editData = new PickupCorporateAddress();
    this.isForceDefault = false;
  }

  onAddressFormSuccess(payload: AddressFormSuccessPayload) {
    this.closeModalAddress();
    this.$emit("addressFormSuccess", payload);
  }
}
